import React from 'react';

export const FormGroup = ({ col, type, name, label, value, readOnly, onChange, ...props }) => (
    <div className={`form-group ${col}`}>
        <label>{label}:</label>
        <input  {...props}
                type={type}
                name={name} 
                value={value} 
                readOnly={readOnly}
                onChange={onChange} />
    </div>
);


// WEBPACK FOOTER //
// ./Public/src/js/util/form-group/index.jsx